/*******************************************************************************
 * Copyright (c) 2019 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *
 *******************************************************************************/

import React from 'react'
import Grid from '@mui/material/Grid'
import Link from '@mui/material/Link'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import { Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui';

import { useTranslation } from 'react-i18next';
const PageFooter = () => {


  const { classes } = useStyles()
  const { t } = useTranslation()
  return (
    <div className={classes.root}>

      <Container maxWidth="xl" component="footer" className={classes.footer}>
        <Grid container spacing={4} justify="space-evenly">
          <Grid item xs={6} sm={4}>
            <Typography variant="h3" className={classes.footerTitle} color="primary" gutterBottom>
              BELLTANE
            </Typography>

            <Typography variant="h5" className={classes.listItemLink} color="primary" gutterBottom>
              {t('descp:contactusEmail')}  : info@belltane.com
            </Typography>

          </Grid>
          <Grid item xs={6} sm={2}>
            <Typography variant="h4" className={classes.footerTitle} color="primary" gutterBottom>
              {t('titles:company')}
            </Typography>
            <ul className={classes.list}>

              <li className={classes.listItem}>
                <Link href="/history" variant="subtitle1" color="primary" className={classes.listItemLink} >
                  {t('titles:history')}
                </Link>
              </li>
              <li className={classes.listItem}>
                <Link href="/contact" variant="subtitle1" color="primary" className={classes.listItemLink} >
                  {t('titles:contactus')}
                </Link>
              </li>
            </ul>
          </Grid>

          <Grid item xs={6} sm={2}>
            <Typography variant="h4" className={classes.footerTitle} color="primary" gutterBottom >
              {t('titles:legal')}
            </Typography>
            <ul className={classes.list}>
              <li className={classes.listItem}>
                <Link href="/privacypolicy" variant="subtitle1" className={classes.listItemLink} >
                  {t('titles:privacypolicy')}
                </Link>
              </li>
              <li className={classes.listItem}>
                <Link href="/tos" variant="subtitle1" className={classes.listItemLink} >
                  {t('titles:tos')}
                </Link>
              </li>
            </ul>
          </Grid>
        </Grid>

      </Container>
      <Grid container
        direction="row"
        justify="center"
        alignItems="center"
        spacing={4}
        className={classes.socialIconsList}
      >
        <Grid item xs={2} sm={4}>
        </Grid>
        <Grid item xs={2} sm={1}>
          <a href="https://www.linkedin.com/company/belltane-llc/" target="_blank" rel="noreferrer">
            <img src="/assets/images/icons/linkedin.png" width={40} alt="linkedin" />
          </a>
        </Grid>
        <Grid item xs={2} sm={1} >
          <a href="https://www.youtube.com/channel/UCA6lf832uxWDc1atW6y6_9g" target="_blank" rel="noreferrer">
            <img src="/assets/images/icons/youtube.png" width={40} alt="youtube" />
          </a>
        </Grid>
        <Grid item xs={2} sm={1}>
          <a href="https://belltane.wordpress.com" target="_blank" rel="noreferrer">
            <img src="/assets/images/icons/wordpress.png" width={40} alt="wordpress" />
          </a>
        </Grid>
        <Grid item xs={2} sm={1}>
          <a href="mailto:info@belltane.com" target="_blank" rel="noreferrer">
            <img src="/assets/images/icons/email.png" width={40} alt="email" />
          </a>
        </Grid>
        <Grid item xs={4} sm={4} >
        </Grid>
      </Grid>

      <Box mt={3}>
        <Typography variant="h4" align="center" className={classes.listItemLink} >
          {'Copyright © '}
          <Link href="https://belltane.com" className={classes.listItemLink}>
            Belltane
          </Link>{' '}
          {new Date().getFullYear()}
          {'.'}
        </Typography>
      </Box>
    </div>
  )

}

const useStyles = makeStyles({ "name": { PageFooter } })((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    color: "black",
    paddingBottom: theme.spacing(2),
    textAlign: 'center',
    [theme.breakpoints.up('sm')]: {
      textAlign: 'left',
      paddingLeft: theme.spacing(3),
    },
  },
  text: {
    color: 'black',
  },
  footer: {
    marginTop: '30px',
    marginBottom: '50px!important',


  },
  listItem: {
    marginBottom: '5px',
    paddingRight: '20px',
    listStyle: 'none'
  },
  listItemLink: {
    fontSize: '16px!important',
    lineHeight: '35px!important',
    transition: 'all .25s cubic-bezier(.645,.045,.355,1)!important',
    textDecoration: 'none!important',
    color: '#fff!important',

  }, footerTitle: {
    fontSize: '25px!important',
    color: '#fff!important',
    marginBottom: '17px!important'
  },
  socialIconsList: {
    background: '#0b0b1e6e!important',
    paddingBottom: '30px!important'

  }
}));

export default PageFooter;
